// src/components/pages/correlation/utils/scoreCalculator.js

export function computeDiversificationBalanceScore(pca) {
  if (!pca || !pca.explainedVariance || pca.explainedVariance.length < 2) return null;
  const ratio = pca.explainedVariance[1] / pca.explainedVariance[0];
  const balanceScore = Math.min(10, ratio * 10);
  return balanceScore.toFixed(1);
}

export function computeCorrelationSpreadScore(correlationMatrix) {
  if (!correlationMatrix || correlationMatrix.length === 0) return null;
  let sum = 0;
  let count = 0;
  const n = correlationMatrix.length;
  for (let i = 0; i < n; i++) {
    for (let j = i + 1; j < n; j++) {
      sum += correlationMatrix[i][j];
      count++;
    }
  }
  const avgCorr = count ? sum / count : 0;
  const score = Math.max(0, Math.min(10, (1 - avgCorr) * 10));
  return score.toFixed(1);
}

export function getCorrelationSpreadInterpretation(score, t) {
  const s = parseFloat(score);
  if (s >= 7) return t("correlation.interpretation.correlationSpread.high");
  else if (s >= 4) return t("correlation.interpretation.correlationSpread.medium");
  else return t("correlation.interpretation.correlationSpread.low");
}

export function getDiversificationBalanceInterpretation(score, t) {
  const s = parseFloat(score);
  if (isNaN(s)) return t("correlation.interpretation.diversificationBalance.notAvailable");
  if (s >= 7.5) return t("correlation.interpretation.diversificationBalance.high");
  else if (s >= 5.0) return t("correlation.interpretation.diversificationBalance.medium");
  else return t("correlation.interpretation.diversificationBalance.low");
}

export function getMarketRiskInterpretation(exposure, t) {
  if (exposure < 40) return t("correlation.interpretation.marketRiskExposure.low");
  else if (exposure >= 40 && exposure <= 70) return t("correlation.interpretation.marketRiskExposure.medium");
  else return t("correlation.interpretation.marketRiskExposure.high");
}